import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { LoginService } from '../login/login.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormArray, EmailValidator } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-incentive-page',
  templateUrl: './incentive-page.component.html',
  styleUrls: ['./incentive-page.component.css']
})
export class IncentivePageComponent implements OnInit {
  showingCases:any=[]
  settingsForm!: FormGroup
  status:any='Add'
  storedData:any
  token:any
  dropdownSettingslocation = {
    singleSelection: false,
    idField: 'item',
    textField: 'item',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  currentCount:any=0
  total:any=0
  AllocationFlag:any=false
  currentSortColumn:any
  Alllocations:any=[]
  selectedlocations:any=[]
  obj:any
  // searchQuery:any=''
  sortField:any
  sortOrder:any
  sortDirection = 'asc'; // 'asc' for ascending, 'desc' for descending
  currentPage: number = 1;
  searchQuery:any=''
  itemsPerPage: number = 25;
  totalItems: number =0
  tableSize: number[] = [5, 10, 20, 50, 100];
  pagingConfig: any = {}
  pageNo: any;
  size: any;
  userTypesTelleCaller:any
  currentMonthForListCases:any
  constructor(private loginService:LoginService,private formBuilder: FormBuilder,private router:Router) {   this.pagingConfig = {
    itemsPerPage: this.itemsPerPage,
    currentPage: this.currentPage,
    totalItems: this.totalItems
  }}

  ngOnInit(): void {
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
    const today = new Date();

    this.currentMonthForListCases = today.toISOString().slice(0, 7); // Format: "YYYY-MM"

    this.token = localStorage.getItem('token');
    this.listUserTypes()
    this.listIncentiveCases()
    this.listSingleAgency()
    this.settingsForm = this.formBuilder.group({
      currentMonth:[today.toISOString().slice(0, 7)],
      targetCount:[''],
      label2:[''],
      label3:[''],


    })
  }
  sortTable(column: string): void {
    // console.log("nvnvss");
    
   this.sortField=column
    if (this.currentSortColumn === column) {
      // Toggle the sort order if the column is already sorted
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      // Set the column to the current sort column and default to ascending
      this.currentSortColumn = column;
      this.sortOrder = 'asc';
    }
    // console.log(this.sortField,this.sortOrder);

  // this.ListCases()
  
    // this.showingCases.sort((a: any, b: any) => {
    //   let valueA = this.getValueByPath(a, column);
    //   let valueB = this.getValueByPath(b, column);
  
    //   // Handle null or undefined values
    //   if (valueA == null) return this.sortOrder === 'asc' ? 1 : -1;
    //   if (valueB == null) return this.sortOrder === 'asc' ? -1 : 1;
  
    //   // Attempt to parse dates
    //   const dateA = this.parseCustomDate(valueA);
    //   const dateB = this.parseCustomDate(valueB);
  
    //   if (dateA && dateB) {
    //     // Compare as dates
    //     if (dateA < dateB) return this.sortOrder === 'asc' ? -1 : 1;
    //     if (dateA > dateB) return this.sortOrder === 'asc' ? 1 : -1;
    //     return 0;
    //   }
  
    //   // Compare as numbers if both are numeric
    //   if (!isNaN(valueA) && !isNaN(valueB)) {
    //     valueA = Number(valueA);
    //     valueB = Number(valueB);
    //     return this.sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
    //   }
  
    //   // Compare as strings (case insensitive)
    //   valueA = String(valueA).toLowerCase();
    //   valueB = String(valueB).toLowerCase();
    //   if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
    //   if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
    //   return 0;
    // });
  }
format(date:any){
          //  return moment(date).format('lll');
           return moment(date).format('DD-MM-YYYY \nHH:mma');
         }

  copyText(text: string) {
      // navigator.clipboard.writeText(text);
      // alert(`Copied: ${text}`);

       navigator.clipboard.writeText(text).then(
        () => {
            const Toast = Swal.mixin({
                  toast: true,
                  position: "center",
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                  }
                });
                Toast.fire({
                  icon: "success",
                  title: "Code copied to clipboard"
                });

        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
}
         
    getStatusClass(status: string): string {
      switch (status) {
        case 'New case':
          return 'status-new-case';
        case 'Under Validation':
          return 'status-under-validation';
        case 'Verified':
          return 'status-verified';
        case 'Under TeleCall':
          return 'status-under-telecall';
        case 'Interested':
          return 'status-interested';
        case 'Not Interested':
          return 'status-not-interested';
        case 'Client Enrolled':
          return 'status-client-enrolled';
        case 'Field Visit':
          return 'status-field-visit';
        default:
          return 'status-default';
      }
    }
    listIncentiveCases(){
      let req={
        searchKey:this.searchQuery,
        page:this.pagingConfig.currentPage,
        limit:this.pagingConfig.itemsPerPage
      }

console.log("bnhv",this.currentMonthForListCases);

      let body={
        month: moment(this.currentMonthForListCases, 'YYYY-MM').format('MMMM'),
        sortField:this.sortField,
        sortOrder:this.sortOrder,
        location:this.selectedlocations
      }
    
                  this.loginService.listIncentiveCases(this.token,req,body)
                             .subscribe((response: any) => {
                             if (response.status === 1) {
                             this.showingCases=response.data
                           
                             this.pagingConfig.totalItems = response.totalCount;
                             this.currentCount=response.count
                             this. total=response.totalCount

                              }
                            })



    }
    compareObjects(o1: any, o2: any): boolean {
      return o1 && o2 ? o1._id === o2._id : o1 === o2;
  }
  
    onTableDataChange(event: any) {
      this.pagingConfig.currentPage = event;
      this.listIncentiveCases()
    }
    onTableSizeChange(event: any): void {
      this.pagingConfig.itemsPerPage = event.target.value;
      this.pagingConfig.currentPage = 1;
      this.size = event.target.value
     this.listIncentiveCases()
  
    }
    submit(){
      if(this.obj.length>0){
        let body={
          month: moment(this.settingsForm.value.currentMonth, 'YYYY-MM').format('MMMM'),
          targetCount:this.settingsForm.value.targetCount,
          _id:this.obj[0]._id,
          label2:this.settingsForm.value.label2,
          label3:this.settingsForm.value.label3
        }
      
                    this.loginService.updateTarget(this.token,body)
                               .subscribe((response: any) => {
                               if (response.status === 1) {
                                    Swal.fire("Success")
  
                                }
                              })
      }else{
        let body={
          month: moment(this.settingsForm.value.currentMonth, 'YYYY-MM').format('MMMM'),
          targetCount:this.settingsForm.value.targetCount,
          label2:this.settingsForm.value.label2,
          label3:this.settingsForm.value.label3
        }
      
                    this.loginService.saveSettings(this.token,body)
                               .subscribe((response: any) => {
                               if (response.status === 100) {
                                    Swal.fire("Success")
  
                                }
                              })
      }
      
    }
    setValue(){
      console.log("jghjghj");
      
      let body={
        // currentMonthForListCases:this.settingsForm.value.currentMonth,
        month: moment(this.settingsForm.value.currentMonth, 'YYYY-MM').format('MMMM'),
        targetCount:this.settingsForm.value.targetCount,
        label2:this.settingsForm.value.label2,
        label3:this.settingsForm.value.label3
      }
    
                  this.loginService.getSettings(this.token,body)
                             .subscribe((response: any) => {
                             if (response.status === 100) {
                            this.obj=response.data
                            console.log(this.obj);
                            
                              const isEmpty = (obj: object): boolean => Object.keys(obj).length === 0;

                              console.log(   this.settingsForm.value,isEmpty);

if(this.obj.length>0){
  this.status='EDIT'
     this.settingsForm.get('targetCount')?.patchValue(response.data[0].targetCount);
     this.settingsForm.get('label2')?.patchValue(response.data[0].label2);
     this.settingsForm.get('label3')?.patchValue(response.data[0].label3);

console.log(   this.settingsForm.value);

                                    // this.settingsForm.get('Value2')?.patchValue(response.data.Value2);
                                    // this.settingsForm.get('Value3')?.patchValue(response.data.Value3);
                                    // this.settingsForm.get('Value4')?.patchValue(response.data.Value4);
}else{
  this.status='Add'
  this.settingsForm.get('targetCount')?.patchValue('');
     this.settingsForm.get('label2')?.patchValue('');
     this.settingsForm.get('label3')?.patchValue('');

}
                                    // this.settingsForm.get('Value1')?.patchValue(response.data.Value1);
                                    // this.settingsForm.get('Value2')?.patchValue(response.data.Value2);
                                    // this.settingsForm.get('Value3')?.patchValue(response.data.Value3);
                                    // this.settingsForm.get('Value4')?.patchValue(response.data.Value4);


                              }
                            })

    }

    listUserTypes(){
      this.loginService.listUserType(this.token)
      .subscribe((response: any) => {
        if (response.status === 1) {
          // this.userTypesTelleCaller =response.data
               let dummy =  response.data.filter((each:any) => each.userType == 'Tele Caller');
let data={
  "userType":dummy[0]._id,

}
                  this.loginService.listStaffs1(this.token,data)
                  .subscribe((response: any) => {
                    if (response.status === 1) {
                      // this.userTypesTelleCaller =response.data
                            this.userTypesTelleCaller = response.result

                    }})




        }})


  
}
ClientDetail(flag: any, obj: any) {
  obj.flag = flag;

  localStorage.setItem('Work', JSON.stringify(obj));
  this.router.navigate(["/view-work"])

} 
update(eachCase: any) {
console.log( eachCase.incentiveTeleCallerId);

  // API request
  const requestBody = {
    _id: eachCase._id, // Ensure 'id' exists in eachCase
    incentiveTeleCallerId: eachCase.incentiveTeleCallerId
  };

  this.loginService.editClient(this.token,requestBody)
  .subscribe((response: any) => {
    if (response.status === 1) {
Swal.fire("Success")           




    }})






}

listSingleAgency(){
  this.loginService.listSingleAgency(this.token,this.storedData.agencyRefId._id)
  .subscribe((response: any) => {
      if (response.status === 1) {
        this.Alllocations=response.data[0].location[0].valueList
        this.Alllocations =  this.Alllocations.map((status :any)=> ({ item: status }));

    
    }})

}
Pushlocation(event:any){
  this.selectedlocations = this.selectedlocations.map((item: any) => item.item);
  this.listIncentiveCases()


}



update1(eachCase: any) {
  console.log( eachCase.incentiveTeleCallerId);
  
    // API request
    const requestBody = {
      _id: eachCase._id, // Ensure 'id' exists in eachCase
      incentiveTeleCallerId:''
    };
  
    this.loginService.editClient(this.token,requestBody)
    .subscribe((response: any) => {
      if (response.status === 1) {
  Swal.fire("Success")           
  
  
  
  
      }})
  
  
  
  
  
  
  }





downLoadPdf(){

  
  const requestBody = {
    month: moment(this.currentMonthForListCases, 'YYYY-MM').format('MMMM'),
    download:true
  };

 

    this.loginService.listIncentiveCases(this.token,{},requestBody)
    .subscribe((response: any) => {
    if (response.status === 1) {
      window.open(response.data,"_self")


     }
   })

}

}